import { Control } from 'react-hook-form';

import ArrowLeft from '@synapex/frontend-shared/icons/arrow-left-20.svg?react';
import ArrowRight from '@synapex/frontend-shared/icons/arrow-right-24.svg?react';

import { Button } from '@/true-fsd/shared/ui/ButtonLink';
import { RhfLabeledInput } from '@/true-fsd/shared/ui/Input';

import { FormInputValues, FormOutputValues } from './schema';
import { ComponentProps, ComponentType, ReactNode } from 'react';

import classes from './CreateSiteForm.module.scss';
import { NavigateFunction, useNavigate } from 'react-router';

type RenderLayoutProps = {
  RenderForm: ComponentType<{ children: ReactNode; className: string }>;

  slotHeader: ReactNode;
  slotTitle: ReactNode;
  slotButtons: ReactNode;

  children: ReactNode;
};

type ButtonProps = {
  navigate: NavigateFunction;
  PrefixIcon?: ComponentType<ComponentProps<'svg'>>;
  SuffixIcon?: ComponentType<ComponentProps<'svg'>>;
  variant: 'primary' | 'secondary';
  children: ReactNode;
};

export type CreateSiteFormProps = {
  RenderLayout: (p: RenderLayoutProps) => ReactNode;
  RenderBack: (p: ButtonProps) => ReactNode;

  isSubmitting: boolean;
  onSubmit: () => Promise<void>;
  control: Control<FormInputValues, unknown, FormOutputValues>;
};
export const CreateSiteForm = ({
  RenderLayout,
  RenderBack,
  onSubmit,
  control,
  isSubmitting,
}: CreateSiteFormProps) => {
  const RenderForm: RenderLayoutProps['RenderForm'] = ({
    children,
    className,
  }) => (
    <form onSubmit={onSubmit} className={className}>
      {children}
    </form>
  );
  const navigate = useNavigate();

  return (
    <RenderLayout
      RenderForm={RenderForm}
      slotHeader={'Добавление целевой ссылки'}
      slotTitle={'Введите полный адрес, куда будет идти трафик'}
      slotButtons={
        <div className={classes.buttons}>
          <RenderBack
            PrefixIcon={ArrowLeft}
            variant={'secondary'}
            navigate={navigate}
          >
            Назад
          </RenderBack>
          <Button
            type="submit"
            SuffixIcon={ArrowRight}
            variant={'primary'}
            loading={isSubmitting}
          >
            Далее
          </Button>
        </div>
      }
    >
      <RhfLabeledInput
        label={'Ссылка на сайт'}
        hint={
          <>
            Если вы ведете ссылку на отдельную страницу сайта, укажите полный
            адрес, например <b>https://synapex.cloud/lp</b>
          </>
        }
        placeholder={'Synapex.ai'}
        name="site_url"
        control={control}
      />
    </RenderLayout>
  );
};
